import FilesApi from '@/api/filesApi'
const files_api = new FilesApi()

//import { i18n } from 'plugins/i18n.js'

import { eventBus } from '@/main'
import Vue from 'vue'
// import Vue from 'vue'

/**
 * Удаляем двойное расширение
 * @param {*} filename
 * @returns 123.txt.txt -> 123.txt
 */
function removeDuplicateExtension(filename) {
  if (!filename) {
    return ''
  }
  const parts = filename.split('.')

  if (parts.length < 2) { return filename }

  const extension = parts.pop()

  if (parts[parts.length - 1] === extension) {
    parts.pop()
  }

  return parts.join('.') + '.' + extension
}

const _saveFile = function (file) {
  let a = document.createElement('a')
  document.body.appendChild(a)
  a.style = 'display: none'
  a.href = file.getUri
  a.download = removeDuplicateExtension(/*file.name || file.title || */file.file.name || file.file.title)
  a.click()
  setTimeout(() => {
    document.body.removeChild(a)
  }, 0)
}

export const allFileTypesNames = {
  doc: 'application/msword',
  docx: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  rtf: 'application/rtf, .rtf',
  xls: 'application/vnd.ms-excel',
  xlsx: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  csv: 'text/csv',
  zip: 'application/zip',
  rar: '.rar', // application/x-rar,
  '7z': '.7z', // application/x-7z,
  gzip: '.gzip', // application/x-gzip,
  ppt: 'application/vnd.ms-powerpoint',
  pptx: 'application/vnd.openxmlformats-officedocument.presentationml.presentation',
  pdf: 'application/pdf',
  djvu: '.djvu', // image/x.djvu
  jpg: 'image/jpeg',
  jpeg: 'image/jpeg',
  png: 'image/png',
  bmp: 'image/bmp',
  gif: 'image/gif',
  tiff: 'image/tiff',
  ai: 'application/illustrator, .ai',
  btkd: 'application/btkd, .btkd',
  eps: '.eps', // extension-only, like djvu/rar
}

const loadingPercentage = (progressEvent) => progressEvent.total
  ? Math.round((progressEvent.loaded * 100) / progressEvent.total)
  : 0

export class CommonFile {
  constructor(file, downloader, uploader, deleter, fileTitle, changer) {
    this.file = file
    this.title = file ? file?.name || file?.title || file?.fileName : fileTitle

    this.downloader = downloader
    this.uploader = uploader
    this.deleter = deleter
    this.changer = changer
    this.loadingPercentage = 0

    this.loading = false
    this.uri = ''
    this.dialog = false
  }

  async downloadFile() {
    if (this.file && !this.file.newEndpoint) {
      return this.file
    }
    if (this.file && this.file.newEndpoint) {
      _saveFile(this)
      return
    }
    let t = this
    const axiosListener = function (progressEvent) {
      t.loadingPercentage = loadingPercentage(progressEvent)
    }

    if (this.downloader && !this.loading && this.loadingPercentage === 0) {
      this.loading = true
      return await this.downloader(axiosListener)
        .then((file) => {
          let types = Object.keys(allFileTypesNames)
          let type = types.find(key => allFileTypesNames[key] == file?.data?.type) || file?.data?.type?.split('/')[1]
          let name = types.find(key =>  this.title.includes(key) ) ? this.title : this.title + '.' + type

          Vue.prototype.$set(this, 'file', new File([file?.data], file?.name || name , { type: file?.headers?.['content-type'] }))
          return this.file
        })
        .finally(() => { this.loading = false })

    }
  }
  async uploadFile( optional, load ) {
    let t = this
    const axiosListener = function (progressEvent) {
      t.loadingPercentage = loadingPercentage(progressEvent)
    }

    if ((this.uploader && !this.loading && this.loadingPercentage === 0) || load) {
      this.loading = true
      return await this.uploader(this.file, axiosListener, this, optional /* optional */)
        .then((result) => {
          this.fileId = result?.data?.length ? result?.data[0].id : null
          this.key = result?.data?.length ? result?.data[0].key : null
          return result
        })
        .finally(() => {
          this.loading = false
        })

    } else  if ( !t.fileId ) {
      t.loadingPercentage = 0
      return await t.uploadFile()
    }
  }
  async uploadAdditionalDocument( optional ) {
    let t = this
    const axiosListener = function (progressEvent) {
      t.loadingPercentage = loadingPercentage(progressEvent)
    }

    if (this.uploader && !this.loading && this.loadingPercentage === 0) {
      this.loading = true
      return await this.uploader(this.file, axiosListener, this, optional /* optional */)
        .then((result) => {
          this.fileId = result?.data?.length ? result?.data[0].id : null
          this.key = result?.data?.length ? result?.data[0].key : null
          return result
        })
        .finally(() => {
          this.loading = false
        })

    } else  if ( !t.fileId ) {
      t.loadingPercentage = 0
      return await t.uploadAdditionalDocument()
    }
  }

  async uploadPublicTenderResultDocument( optional ) {
    let t = this
    const axiosListener = function (progressEvent) {
      t.loadingPercentage = loadingPercentage(progressEvent)
    }

    if (this.uploader && !this.loading && this.loadingPercentage === 0) {
      this.loading = true
      return await this.uploader(this.file, axiosListener, this, optional /* optional */)
        .then((result) => {
          this.fileId = result?.data?.length ? result?.data[0].id : null
          this.key = result?.data?.length ? result?.data[0].key : null
          return result
        })
        .finally(() => {
          this.loading = false
        })

    } else  if ( !t.fileId ) {
      t.loadingPercentage = 0
      return await t.uploadPublicTenderResultDocument()
    }
  }
  catchUploading(er, catch_it) {
    let text_er = er?.response?.data || er
    text_er = Array.isArray(text_er) ? text_er.join(', ') : text_er.File ? text_er.File[0] : text_er
    eventBus.$emit('showErrorSnackbar',  this.title + '  ' +  eventBus.$t('Tenders.FailedFileLoad') + '  ' + text_er)
    this.error = eventBus.$t('Tenders.FailedFileLoad') + '  ' + text_er
    // this.files = this.files.slice(0)
    if ( !catch_it ) {
      throw er
    }

  }
  async changeFile(file) {
    // let t = this
    const axiosListener = function (progressEvent) {
      file.loadingPercentage = loadingPercentage(progressEvent)
    }

    if (this.changer && !this.loading && !file.loading && file.loadingPercentage === 0) {
      file.loading = true
      return await this.changer(file, axiosListener, this /* optional */)
        .then((result) => {
          file.fileId = result.data?.id || null
          file.key = result.data?.key || null
          return result
        })
        /*.catch(error => {
          Vue.prototype.$notice.error({
            title: i18n.t('Common.ErrorTitle'),
            message: error?.message || '',
            duration: 10,
          })
        })*/
        .finally(() => {
          file.loading = false
        })

    }
    // else  if ( !t.fileId ) {
    //   t.loadingPercentage = 0
    //   return await t.uploadFile()
    // }
  }
  async deleteFile() {
    this.loading = true
    this.loadingPercentage = 0
    if (this.deleter) {
      return await this.deleter(this)
        .finally(() => {
          this.loading = false
        })
    }
  }
  async saveFile() {
    if (!this.file) {
      await this.downloadFile()
    }
    _saveFile(this)
  }
  get getUri() {
    if (!this.uri) {
      this.uri = window.URL.createObjectURL(this.file)
    }
    return this.uri
  }
  get getFileSize() {
    if (this.file) {
      return this.file.size
    }
    return this.size
  }
  get getFileExtension() {
    var ext = /^.+\.([^.]+)$/.exec(this.title)
    return ext == null ? '' : ext[1].trim().toLowerCase()
  }
  static GetFileExtention(file) {
    var ext = /^.+\.([^.]+)$/.exec(file)
    return ext == null ? '' : ext[1].trim().toLowerCase()
  }
}

export class TenderFile extends CommonFile {
  /**
   *
   * @param {*} file Если передать, не будет работать загрузка файла. Т.к. будет вытатся в getUri по файлу
   * @param {*} documentType Признак публичного или внутреннего документа. Для внутренних свое api
   */
  constructor(tenderId, fileId, fileKey, file, fileName, size, documentType = 'PUBLIC') {
    super(file,
      // downloader
      (listener) => files_api.getDocument(tenderId, fileId, listener),
      // uploader
      (file, listener) => files_api.uploadDocument(tenderId, file, listener),
      // deleter
      () => this.deleteByType(),
      fileName,
      // changer
      (new_file, listener) => this.changerByType(new_file, listener),
    )

    this.documentType = documentType
    this.tenderId = tenderId
    this.fileId = fileId
    this.key = fileKey
    this.size = size
  }
  async deleteByType() {
    if (!this) { return null }
    if (this.documentType === 'PUBLIC') {
      return await files_api.deleteDocument(this.tenderId, this.fileId, null)
    } else if (this.documentType === 'INTERNAL') {
      return await files_api.deleteAdditionalDocument(this.tenderId, this.fileId, null)
    } else if (this.documentType === 'PUBLIC_RESULTS') {
      return await files_api.deletePublicTenderResultDocument(this.tenderId, this.fileId, null)
    }
  }
  async changerByType(newFile, listener) {
    if (!this) { return null }
    if (this.documentType === 'PUBLIC') {
      return await files_api.changeDocument(this.tenderId, this.fileId, newFile.file, listener)
    } else if (this.documentType === 'INTERNAL') {
      return await files_api.changeAdditionalDocument(this.tenderId, this.fileId, newFile.file, listener)
    } else if (this.documentType === 'PUBLIC_RESULTS') {
      return await files_api.changePublicTenderResultDocument(this.tenderId, this.fileId, newFile.file, listener)
    }
  }
}

export class FeedbackFile extends CommonFile {
  constructor(taskId, file, fileName) {
    super(file,
      // downloader
      null,
      // uploader
      (file, listener, that) => files_api.addTaskAttachment(that.taskId, file.name, file, listener),
      // deleter
      null,

      file ? file.name : fileName)
    this.taskId = taskId
  }

  get taskId() {
    return this._taskId
  }

  set taskId(val) {
    this._taskId = val
  }
}


export class XlsImportCartTemplateFile extends CommonFile {
  constructor() {
    super(null,
      // downloader
      (listender) => files_api.downloadXlsTemplate(listender),
      // uploader
      null,
      // deleter
      null,

      'template')
  }
}

export class XlsImportCartFile extends CommonFile {
  constructor(file) {
    super(file,
      // downloader
      null,
      // uploader
      (file, listener) => files_api.uploadXlsToCart(file, listener),
      // deleter
      null,

      file.name)
  }
}

export class StorageFile extends CommonFile {
  constructor(entityId, file, storageType) {
    file.newEndpoint = true

    super(file,
      // downloader
      (listener) => files_api.geStorageDocument(this.fileId, listener),
      // uploader
      (file, listener) => files_api.uploadStorageDocument(entityId, file, this.documentType, listener),
      // deleter
      (file, listener) => files_api.deleteStorageDocument(entityId, this.fileId, this.documentType, listener),

      null)

    this.documentType = storageType //Purchasing, Crm, Accreditation
    this.fileId = file?.id || file?.key
    this.key = file?.key || file?.id
    this.size = file?.size
    this.isActive = true
    this.entityId = entityId
    this.dateModified = file.modified?.date ?? file.modifier?.date ?? file.dateModified

    this.error = false
    this.uri = this.key ? `${window.config.GrapgQlUrl}/document/${this.key}` : null
  }

  /**
   * Пересоздаёт uploader и deleter с новым entityId
   * @param {string|number} newEntityId
   */
  updateEntityId(newEntityId) {
    this.entityId = newEntityId
    this.uploader = (file, listener) => files_api.uploadStorageDocument(newEntityId, file, this.documentType, listener)
    this.deleter = (file, listener) => files_api.deleteStorageDocument(newEntityId, this.fileId, this.documentType, listener)
  }
}

export class StopListFile extends CommonFile {
  constructor(file, info,) {
    super(file,
      // downloader
      null,
      // (listener) => files_api.downloadStopDocument(info.key, listener),
      // uploader
      (file, listener, that, optional) => files_api.uploadStopDocument( optional, file, listener),
      // deleter
      null,

      file?.name || info?.title)

    this.fileId = info?.id  || file?.id
    this.key = info?.key || file?.key
    this.size = info?.size || file?.size
  }
}

export class AdditionalDocumentFile extends CommonFile {
  constructor(tenderId, fileId, fileKey, file, fileName) {
    super(file,
      // downloader
      null,
      // uploader
      (file, listener) => files_api.uploadAdditionalDocument(tenderId, file, listener),
      // deleter
      null,
      fileName,
      // changer
      null,)
    this.fileId = file.fileId
    this.size = file.size
    this.key = fileKey
  }
}

export class CommercialOfferDocumentFile extends CommonFile {
  constructor(tenderId, fileId, fileKey, file, fileName) {
    super(file,
      // downloader
      null,
      // uploader
      //(file, listener) => files_api.uploadCommercialOfferDocumen(tenderId, file, listener),
      (file, listener) => files_api.addComercialOferDocument(tenderId, file, listener),
      // deleter
      () => files_api.deleteComercialOferDocument(tenderId, fileId, null),
      fileName,
      // changer
      null,)
    this.tenderId = tenderId
    this.fileId = file.fileId
    this.size = file.size
    this.key = fileKey
  }
}

export class ExternalDocumentFile extends CommonFile {
  constructor(tenderId, fileId, fileKey, file, fileName) {
    super(file,
      // downloader
      null,
      // uploader
      (file, listener) => files_api.uploadPublicTenderResultDocument(tenderId, file, listener),
      // deleter
      null,
      fileName,
      // changer
      null,)
    this.fileId = file.fileId
    this.size = file.size
    this.key = fileKey
  }
}
export class QuestionFile extends CommonFile {
  constructor(file) {
    super(file,
      // downloader
      null,
      // uploader
      (file, listener, that, optional) => files_api.uploadQuestionDocument( optional, file, listener),
      // deleter
      null,

      file.name)
    this.fileId = file.id
    this.size = file.size
    this.key = file?.key

    this.uri = `${window.config?.SmarttenderUrl}/Attachment/DownloadAttachmentByKey/${this.key}`
  }
}

export class TenderLotFile extends CommonFile {
  constructor(file, tenderId, nameApi = 'uploadLotsWithAdditional') {
    super(file,
      // downloader
      null,
      // uploader
      (file) => files_api[nameApi](file, tenderId),
      // deleter
      null,

      file.name)
  }
}

export class TenderLotTemplateFile extends CommonFile {
  constructor(uri, fileName) {
    super(null,
      // downloader
      (listender) => files_api.getLotImportTemplate(uri, listender),
      // uploader
      null,
      // deleter
      null,
      fileName || 'template')
  }
}

export class TendersFile extends CommonFile {
  constructor(search, withLots) {
    super(null,
      // downloader
      (listender) => files_api.downloadXlsTenders( search, withLots, listender),
      // uploader
      null,
      // deleter
      null,

      'Tenders')
  }
}
export class commercialOfferFile extends CommonFile {
  constructor(tenderId, fileName) {
    super(null,
      // downloader
      (listener) => files_api.downloadCommercialOffer(tenderId, listener),
      // uploader
      null,
      // deleter
      null,
      fileName)
  }
}
export class BidsHistoryReportFile extends CommonFile {
  constructor(tenderId, fileName) {
    super(null,
      // downloader
      (listener) => files_api.getBidsHistory(tenderId, listener),
      // uploader
      null,
      // deleter
      null,

      fileName)
  }
}
export class ForeignOfferFile extends CommonFile {
  constructor(file) {
    super(file,
      // downloader
      null,
      // uploader
      (file, listener) => files_api.addBidAttachment( file , listener ),
      // deleter
      null,

      file.name)
  }
}
